<section class="wishlist-access-panel" aria-labelledby="wishlist-access-panel-title">
  <div class="wishlist-access-panel__title">
    <h3 id="wishlist-access-panel-title">Link</h3>
    <wishlist-status-pill
      [label]="view().shareLinkStatusLabel"
      [tone]="view().shareLinkStatusTone"
    />
  </div>

  @if (view().shareUrl) {
    <ui-input
      label="Link publiczny"
      name="wishlistShareUrl"
      [value]="view().shareUrl ?? ''"
      [readonly]="true"
      ariaLabel="Link publiczny wishlisty"
    />
  }

  @if (view().linkActionHint) {
    <p class="wishlist-access-panel__hint">
      {{ view().linkActionHint }}
    </p>
  }

  <div class="wishlist-access-panel__actions">
    @if (view().canCreateLink) {
      <ui-button
        size="sm"
        variant="secondary"
        [disabled]="view().pending"
        (pressed)="handleCreateLinkSelected()"
      >
        Utwórz link
      </ui-button>
    }

    @if (view().canCopyLink) {
      <ui-button
        size="sm"
        variant="secondary"
        [disabled]="view().pending"
        (pressed)="handleCopyLinkSelected()"
      >
        Kopiuj link
      </ui-button>
    }

    @if (view().canRotateLink) {
      <ui-button
        size="sm"
        variant="secondary"
        [disabled]="view().pending"
        (pressed)="handleRotateLinkSelected()"
      >
        Regeneruj link
      </ui-button>
    }

    @if (view().canDisableLink) {
      <ui-button
        size="sm"
        variant="ghost"
        [disabled]="view().pending"
        (pressed)="handleDisableLinkSelected()"
      >
        Wyłącz link
      </ui-button>
    }
  </div>
</section>
